import type { ChatBase, ChatPatient } from "@/types/chat";

/**
 * The patient this chat's messages and @-suggestions are about: the primary
 * unless archived, else the only active patient. Undefined when a shared
 * number needs staff to pick. Mirrors `resolve_portal_recipient_id` on the server.
 */
export function getActiveRecipient(
  chat: Pick<ChatBase, "patients" | "primaryPatientId"> | null | undefined,
): ChatPatient | undefined {
  const active = chat?.patients?.filter((p) => !p.isArchived) ?? [];
  return (
    active.find((p) => p.id === chat?.primaryPatientId) ??
    (active.length === 1 ? active[0] : undefined)
  );
}

export function getSmsOptOutMessage(
  chat: Pick<ChatBase, "patientOptedOutOfSms" | "clinicOptedOutOfSms">,
): string | null {
  if (chat.patientOptedOutOfSms) {
    return "The patient has opted out of SMS messages.";
  }
  if (chat.clinicOptedOutOfSms) {
    return "The clinic has blocked SMS messages to this number.";
  }
  return null;
}

export function getSmsBlockedMessage(
  chat: Pick<
    ChatBase,
    "patientOptedOutOfSms" | "clinicOptedOutOfSms" | "isLandlineNumber"
  >,
): string | null {
  if (chat.isLandlineNumber) {
    return "This number is a landline and cannot receive SMS messages.";
  }
  return getSmsOptOutMessage(chat);
}
